import React from 'react';
import SwissCross from './SwissCross';
import CtaButton from './CtaButton';

const links = [
  { href: '#inhalt', label: 'Inhalt' },
  { href: '#vorteile', label: 'Vorteile' },
  { href: '#faq', label: 'FAQ' }
];

// Sticky Header mit Sprungmarken und CTA
function Header() {
  return (
    <header className="sticky top-0 z-50 border-b border-gray-200 bg-[#F9FAFB]/90 backdrop-blur">
      <div className="mx-auto flex h-16 max-w-6xl items-center justify-between px-4">
        <a href="#top" className="flex items-center gap-2 font-extrabold text-[#111827]">
          <SwissCross />
          <span>Praxisratgeber Schweiz</span>
        </a>
        <nav className="flex items-center gap-5" aria-label="Hauptnavigation">
          {links.map((l) => (
            <a key={l.href} href={l.href} className="hidden text-sm font-medium text-gray-600 hover:text-[#D52B1E] md:block">
              {l.label}
            </a>
          ))}
          <CtaButton>
            <span className="hidden sm:inline">Bei Amazon bestellen</span>
            <span className="sm:hidden">Bestellen</span>
          </CtaButton>
        </nav>
      </div>
    </header>
  );
}

export default Header;